module.exports = __webpack_public_path__ + "img/dong-ho.5344fe7d.svg";